import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// MarkdownText — рендер разобранного markdown-подмножества (FR-MSG-02) в безопасные React-узлы.
// Парсинг живёт в util/markdown (владелец = design-system, R2-G); здесь — только отображение токенов.
// Ссылки кликабельны, БЕЗ unfurl (D-03). Упоминания подсвечиваются акцентом, по клику — колбэк.
import { Fragment } from 'react';
import { parseMarkdown } from '../util/markdown.js';
const codeStyle = {
    fontFamily: 'var(--font-family-mono)',
    background: 'var(--color-code-bg)',
    borderRadius: '4px',
    padding: '0 4px',
    fontSize: '0.92em',
};
const preStyle = {
    fontFamily: 'var(--font-family-mono)',
    background: 'var(--color-code-bg)',
    borderRadius: 'var(--radius-control)',
    padding: 'var(--space-2) var(--space-3)',
    margin: 'var(--space-1) 0',
    overflowX: 'auto',
    // относительно текста пузыря (--font-message): моноширинный визуально крупнее — чуть меньше em
    fontSize: '0.88em',
    whiteSpace: 'pre-wrap',
};
const linkStyle = { color: 'var(--color-link)', textDecoration: 'underline' };
const mentionStyle = {
    color: 'var(--color-accent)',
    fontWeight: 'var(--weight-medium)',
    cursor: 'pointer',
};
function renderNodes(nodes, props, keyPrefix) {
    return nodes.map((node, i) => {
        const key = `${keyPrefix}-${i}`;
        switch (node.type) {
            case 'text':
                return _jsx(Fragment, { children: node.value }, key);
            case 'bold':
                return (_jsx("strong", { "data-md": "bold", children: renderNodes(node.children, props, key) }, key));
            case 'italic':
                return (_jsx("em", { "data-md": "italic", children: renderNodes(node.children, props, key) }, key));
            case 'code':
                return (_jsx("code", { "data-md": "code", style: codeStyle, children: node.value }, key));
            case 'pre':
                return (_jsx("pre", { "data-md": "pre", style: preStyle, children: node.value }, key));
            case 'link':
                return (_jsx("a", { "data-md": "link", href: node.href, target: "_blank", rel: "noopener noreferrer nofollow", style: linkStyle, onClick: (e) => {
                        if (props.onLinkClick) {
                            e.preventDefault();
                            props.onLinkClick(node.href);
                        }
                    }, children: node.label }, key));
            case 'mention':
                return (_jsxs("span", { "data-md": "mention", "data-handle": node.handle, role: props.onMentionClick ? 'button' : undefined, tabIndex: props.onMentionClick ? 0 : undefined, style: mentionStyle, onClick: () => props.onMentionClick?.(node.handle), children: ["@", node.handle] }, key));
            default:
                return null;
        }
    });
}
// ENT-2 (из форка «Наш.Чат» 03.11.2026): переносы строк в сообщении видны. Раньше одиночный перенос внутри
// абзаца браузер схлопывал в пробел (white-space: normal), а пустая строка между абзацами пропадала
// (блоки шли вплотную) — набранные с телефона абзацы приходили одной строкой.
const paragraphStyle = { display: 'block', whiteSpace: 'pre-wrap' };
/** Абзац после абзаца — отступ в одну строку текста (так выглядит пустая строка, которую набрали). */
const paragraphAfterParagraphStyle = {
    ...paragraphStyle,
    marginTop: 'calc(var(--line-normal) * 1em)',
};
export function MarkdownText(props) {
    const blocks = parseMarkdown(props.text);
    return (_jsx("span", { "data-markdown": "", children: blocks.map((block, bi) => {
            if (block.type === 'pre') {
                return (_jsx("pre", { "data-md": "pre", style: preStyle, children: block.value }, `b-${bi}`));
            }
            const afterParagraph = bi > 0 && blocks[bi - 1]?.type === 'paragraph';
            return (_jsx("span", { "data-md": "paragraph", style: afterParagraph ? paragraphAfterParagraphStyle : paragraphStyle, children: renderNodes(block.children, props, `b-${bi}`) }, `b-${bi}`));
        }) }));
}
//# sourceMappingURL=MarkdownText.js.map